import { Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../assets/svg/svg27.svg";
import InsideHeader from "../../components/InsideHeader";
import { cashConverter, dateForHumans } from "../../utils";
import { setFolderObj } from "../../features/folder/folderSlice";
import DeleteModal from "../../components/DeleteModal";
import { fetchStoreItem } from "../../features/dropdown/dropdownSlice";
import { deleteStoreItem } from "../../features/staff-setting/staffSettingSlice";
import TableLoading from "../../components/TableLoading";
import AddStoreItemModal from "./modal/AddStoreItemModal";
import Search from "../../components/Search";

export default function StoreItemTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { storeItemData, loading, storeItemCount } = useSelector(
    (state) => state.dropdown
  );
  const { staffloading } = useSelector((state) => state.staff);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }

  const [searchInput, setsearchInput] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
  };

  const filterDataList = searchInput
    ? storeItemData?.filter((item) =>
        item?.stName?.toLowerCase().includes(searchInput.toLowerCase())
      )
    : storeItemData;

  async function handleAdd() {
    await setProdd("");
    await setopen(true);
  }

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      deleteStoreItem({
        stId: prodd?.stId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchStoreItemData();
      await setIsModalOpenDelete(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleEdit = () => {
    setopen(true);
  };

  const handleView = async () => {
    await dispatch(setFolderObj(prodd));
    await navigate("/ledger-items");
  };
  const settingItems = [
    {
      key: "3",
      label: (
        <Link
          onClick={handleEdit}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },
    {
      key: "0",
      label: (
        <Link
          onClick={handleView}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Details
        </Link>
      ),
    },
    {
      key: "1",
      label: (
        <Link
          onClick={showModalDelete}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Delete
        </Link>
      ),
    },
  ];

  const columns = [
    {
      title: "Item Name",
      dataIndex: "stName",
      sorter: (a, b) => a.stName.localeCompare(b.stName),
    },
    {
      title: "Quantity",
      dataIndex: "stQuantity",
      sorter: (a, b) => a.stQuantity - b.stQuantity,
    },
    {
      title: "Unit Cost",
      dataIndex: "stUnitCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.stUnitCost - b.stUnitCost,
    },
    {
      title: "Unit of Measure",
      dataIndex: "stUnitOfMeasure",
      sorter: (a, b) => a.stUnitOfMeasure.localeCompare(b.stUnitOfMeasure),
    },
    {
      title: "Description",
      dataIndex: "stDescription",
      sorter: (a, b) => a.stDescription.localeCompare(b.stDescription),
    },
    {
      title: "Status",
      dataIndex: "stStatus",
      sorter: (a, b) => a.stStatus.localeCompare(b.stStatus),
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchStoreItemData(page, size) {
    dispatch(
      fetchStoreItem({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchStoreItemData();
  }, []);
  
  if (loading) return <TableLoading />;

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Store item Information"
        subtitle="Manage store items within your institution"
        back={false}
      />
      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
            Store Item Details
          </h3>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="w-[16.8125rem] lg:mt-0 mt-3">
              <Search
                searchInput={searchInput}
                handleSearch={handleSearch}
                text={"Search store item..."}
              />
            </div>

            <div className="w-[250px]">
              <button onClick={() => handleAdd()} className="cstm-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M19.5 11H13.5V5C13.5 4.73478 13.3946 4.48043 13.2071 4.29289C13.0196 4.10536 12.7652 4 12.5 4C12.2348 4 11.9804 4.10536 11.7929 4.29289C11.6054 4.48043 11.5 4.73478 11.5 5V11H5.5C5.23478 11 4.98043 11.1054 4.79289 11.2929C4.60536 11.4804 4.5 11.7348 4.5 12C4.5 12.2652 4.60536 12.5196 4.79289 12.7071C4.98043 12.8946 5.23478 13 5.5 13H11.5V19C11.5 19.2652 11.6054 19.5196 11.7929 19.7071C11.9804 19.8946 12.2348 20 12.5 20C12.7652 20 13.0196 19.8946 13.2071 19.7071C13.3946 19.5196 13.5 19.2652 13.5 19V13H19.5C19.7652 13 20.0196 12.8946 20.2071 12.7071C20.3946 12.5196 20.5 12.2652 20.5 12C20.5 11.7348 20.3946 11.4804 20.2071 11.2929C20.0196 11.1054 19.7652 11 19.5 11Z"
                    fill="#FFCD47"
                  />
                </svg>
                <span className="ml-1">Add Store Item</span>
              </button>
            </div>
          </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.stId}
                columns={columns}
                dataSource={filterDataList}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: storeItemCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchStoreItemData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={staffloading}
        content={`Are you sure you want to delete ${prodd?.stName}?`}
        title={`Delete ${prodd?.stName}`}
      />

      <AddStoreItemModal
        handleFetchData={fetchStoreItemData}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd}
      />
    </div>
  );
}
